window.arjoInvestorsNavigationModule =
  window.arjoInvestorsNavigationModule ||
  (() => {
    const state = {
      isInitialized: false,
    };

    const setUp = () => {
      if (window.arjoJs.isMobile())
        document.querySelector('.arjo-m-investors-nav .arjo-a-link--current')?.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'end',
        });
    };

    const init = () => {
      if (state.isInitialized) return;
      setUp();
      state.isInitialized = true;
    };

    return { init };
  })();
window.addEventListener('load', window.arjoInvestorsNavigationModule.init);
